import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { LanguageProvider } from "./contexts/LanguageContext";
import { AuthProvider } from "./contexts/AuthContext";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import ProtectedAdminRoute from "./components/ProtectedAdminRoute";
import Home from "./pages/Home";
import Locations from "./pages/Locations";
import Register from "./pages/Register";
import About from "./pages/About";
import Tools from "./pages/Tools";
import VolunteerApplicationForm from "./pages/VolunteerApplicationForm";
import News from "./pages/News";
import LiveBroadcast from "./pages/LiveBroadcast";
import LiveBroadcastManager from "./pages/admin/LiveBroadcastManager";
import AdminLogin from "./pages/admin/AdminLogin";
import AdminLayout from "./pages/admin/AdminLayout";
import Dashboard from "./pages/admin/Dashboard";
import Registrations from "./pages/admin/Registrations";
import Broadcasts from "./pages/admin/Broadcasts";
import EmailTemplates from "./pages/admin/EmailTemplates";
import EmailLogs from "./pages/admin/EmailLogs";
import Settings from "./pages/admin/Settings";
import NewsManager from "./pages/admin/NewsManager";
import PrivacyPolicy from "./pages/PrivacyPolicy";

function PublicShell({ children }) {
  const location = useLocation();
  const isAdmin = location.pathname.startsWith("/admin");
  return (
    <>
      {!isAdmin && <Navbar />}
      {children}
      {!isAdmin && <Footer />}
    </>
  );
}

function App() {
  return (
    <LanguageProvider>
      <AuthProvider>
        <div className="App">
          <BrowserRouter>
            <PublicShell>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/locations" element={<Locations />} />
                <Route path="/register" element={<Register />} />
                <Route path="/about" element={<About />} />
                <Route path="/tools" element={<Tools />} />
                <Route path="/tools/volunteer-application" element={<VolunteerApplicationForm />} />
                <Route path="/news" element={<News />} />
                <Route path="/live" element={<LiveBroadcast />} />
                <Route path="/privacy-policy" element={<PrivacyPolicy />} />

                {/* Admin routes */}
                <Route path="/admin/login" element={<AdminLogin />} />
                <Route
                  path="/admin"
                  element={
                    <ProtectedAdminRoute>
                      <AdminLayout />
                    </ProtectedAdminRoute>
                  }
                >
                  <Route index element={<Dashboard />} />
                  <Route path="registrations" element={<Registrations />} />
                  <Route path="broadcasts" element={<Broadcasts />} />
                  <Route path="news" element={<NewsManager />} />
                  <Route path="live" element={<LiveBroadcastManager />} />
                  <Route path="email-templates" element={<EmailTemplates />} />
                  <Route path="email-logs" element={<EmailLogs />} />
                  <Route path="settings" element={<Settings />} />
                </Route>
              </Routes>
            </PublicShell>
          </BrowserRouter>
        </div>
      </AuthProvider>
    </LanguageProvider>
  );
}

export default App;
